import { render, staticRenderFns } from "./PaymentTermViewGlobal.vue?vue&type=template&id=e7172aec"
import script from "./PaymentTermViewGlobal.vue?vue&type=script&lang=js"
export * from "./PaymentTermViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports